<!-- =========================================================================================
  File Name: DataListListView.vuee
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="data-list-list-view" class="data-list-container">
		<vs-table
			ref="table"
			v-model="selected"
			pagination
			search
			hoverFlat
			:multiple="customConfig.rowSelectionMultiple"
			:max-items="itemsPerPage"
			:data="activities"
		>
			<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
				<vs-button
					v-if="!customConfig.btnAssignActivity"
					type="filled"
					class="g-btn-customize p-0 btnCustom"
					icon-pack="feather"
					icon="icon-plus"
					@click.prevent="$emit('valueCreateActivity', 1)"
				>
					<span class="btnTextCustom">{{ $t("general.New2") + " " + $t("Activity.Activity") }}</span>
				</vs-button>
			</div>

			<template slot="thead">
				<vs-th
					v-if="enableHeadTable('name')"
					class="g-table--title"
					sort-key="name"
					v-text="$t('Name')"
				></vs-th>
				<vs-th
					v-if="enableHeadTable('description')"
					class="g-table--title"
					sort-key="category"
					v-text="$t('Description')"
				></vs-th>
				<vs-th
					v-if="enableHeadTable('active_form')"
					class="g-table--title"
					sort-key="order_status"
					v-text="$t('Activity.Form')"
				></vs-th>
				<vs-th
					v-if="enableHeadTable('service_time')"
					class="g-table--title"
					sort-key="price"
					v-text="$t('Activity.ServiceTime')"
				></vs-th>
				<vs-th
					v-if="enableHeadTable('resource_id')"
					class="g-table--title"
					sort-key="price"
					v-text="$t('Activity.AssignedResources')"
				></vs-th>
				<vs-th
					v-if="enableHeadTable('group_id')"
					class="g-table--title"
					sort-key="price"
					v-text="$t('Activity.AssignedGroups')"
				></vs-th>
				<vs-th v-if="enableHeadTable('action')" class="g-table--title" v-text="$t('Actions')"></vs-th>
			</template>
			<template slot-scope="{data}">
				<tbody>
					<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
						<vs-td v-if="enableHeadTable('name')">
							<p class="g-table--description truncate">
								{{ tr.name }}
							</p>
						</vs-td>

						<vs-td v-if="enableHeadTable('description')">
							<p class="g-table--description">
								{{ tr.description | title }}
							</p>
						</vs-td>

						<vs-td v-if="enableHeadTable('active_form')">
							<vs-button
								type="line"
								class="g-table--description"
								:color="getOrderStatusColor(tr.active_form)"
								>{{ withForm(tr.active_form) }}
							</vs-button>
						</vs-td>

						<vs-td v-if="enableHeadTable('service_time')">
							<p class="g-table--description">{{ tr.service_time }}</p>
						</vs-td>

						<vs-td v-if="enableHeadTable('resource_id')">
							<p class="g-table--description">{{ tr.count_resource || tr.total_resource }}</p>
						</vs-td>
						<vs-td v-if="enableHeadTable('group_id')">
							<p class="g-table--description">{{ tr.count_group || tr.total_group }}</p>
						</vs-td>

						<vs-td v-if="enableHeadTable('action')" class="g-table--description whitespace-no-wrap">
							<feather-icon
								icon="Edit2Icon"
								svgClasses="w-5 h-5 hover:text-primary stroke-current"
								class="g-label--normal"
								@click.stop="editData(tr)"
							/>
							<feather-icon
								v-if="activityDeletePermission"
								icon="Trash2Icon"
								svgClasses="w-5 h-5 hover:text-danger stroke-current"
								class="ml-2 g-label--normal"
								@click.stop="openConfirm(tr)"
							/>
						</vs-td>
					</vs-tr>
				</tbody>
			</template>
		</vs-table>
		<vs-prompt
			@cancel="cancel"
			@accept="deleteData"
			@close="cancel"
			:is-valid="validName"
			:active.sync="activePromptDelete"
			:acceptText="$t('Accept')"
			:cancelText="$t('Cancel')"
			:title="$t('Confirm')"
		>
			<div class="con-exemple-prompt">
				{{ $t("DeleteActivity") }}: <span class="font-semibold">{{ selectedActivity.name }}</span>
				<vs-alert :active="!validName" color="danger" icon="new_releases" class="mt-2">
					{{ $t("DeleteActivityConfirm") }}
				</vs-alert>

				<vs-input :placeholder="$t('Name')" v-model.trim="activityName" class="w-full mt-2" />
			</div>
		</vs-prompt>
		<!-- ASSIGNED GROUPS -->
		<div class="text-right">
			<vs-button
				v-if="customConfig.btnAssignActivity"
				type="filled"
				class="g-btn--resourcePopup"
				@click.prevent="btnAssignHandleClick"
			>
				{{ $t("Activity.AssignActivities") }}
			</vs-button>
		</div>
	</div>
</template>

<script>
import Activity from "@/models/Activity.js";
import moduleActivity from "@/store/activity/moduleActivity.js";
import Commons from "@/helpers/commons.js";

export default {
	props: {
		customConfig: {
			type: Object,
			default: () => {
				return {
					actionDropdown: true,
					btnAssignActivity: false,
					columns: [
						"name",
						"description",
						"active_form",
						"service_time",
						"resource_id",
						"group_id",
						"action",
					],
					rowSelectionMultiple: true,
				};
			},
		},
		customFunction: {
			type: Function,
			default: () => {},
		},
	},
	data() {
		return {
			selected: [],
			itemsPerPage: 5,
			isMounted: false,
			dataId: null,
			activePromptDelete: false,
			activityName: "",
			selectedActivity: {},
			validName: false,
		};
	},
	created() {
		if (!moduleActivity.isRegistered) {
			this.$store.registerModule("moduleActivity", moduleActivity);
			moduleActivity.isRegistered = true;
		}
		if (this.$store.state.moduleActivity.activities.length <= 0) {
			this.openLoading();
			this.$store
				.dispatch("moduleActivity/fetchActivityListItems")
				.then((res) => this.closeLoading())
				.catch((err) => {
					this.closeLoading();
					Commons.manageError.call(this, err);
					throw new Error(err);
				});
		}
	},
	mounted() {
		this.isMounted = true;
	},
	watch: {
		activityName(val) {
			if (val.length > 0 && val.toLocaleLowerCase() === this.selectedActivity.name.toLocaleLowerCase()) {
				this.validName = true;
			} else {
				this.validName = false;
			}
		},
	},
	computed: {
		activityDeletePermission() {
			return this.$store.getters.checkPermission("ACTIVITY_D");
		},
		activityUpdatePermission() {
			return this.$store.getters.checkPermission("ACTIVITY_U");
		},
		currentPage() {
			if (this.isMounted) {
				return this.$refs.table.currentx;
			}
			return 0;
		},
		activities() {
			return this.$store.state.moduleActivity.activities;
		},
		queriedItems() {
			return this.$refs.table ? this.$refs.table.queriedResults.length : this.activities.length;
		},
		withForm() {
			return (value) => {
				if (value === 0 || !value) {
					return this.$t("Activity.Inactivated");
				} else {
					return this.$t("Activity.Activated");
				}
			};
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		addNewData() {
			this.$router.push({name: "app-activity-create"});
		},
		enableHeadTable(headName) {
			return this.customConfig.columns.includes(headName);
		},
		deleteData() {
			this.openLoading();
			this.$store
				.dispatch("moduleActivity/removeActivityItem", this.dataId)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("TitleConfirmActivityDelete"),
						text: this.$t("TextConfirmActivityDelete"),
					});
					this.closeLoading();
					this.cancel();
				})
				.catch((err) => {
					this.closeLoading();
					throw new Error(err);
				});
		},
		openConfirm(activity) {
			this.dataId = activity.id;
			this.selectedActivity = new Activity(activity);
			this.activePromptDelete = true;
		},
		editData(data) {
			this.$emit("selectedActivityEmit", new Activity(data));
		},
		getOrderStatusColor(status) {
			if (status === 0 || !status) return "warning";
			if (status === 1 || status) return "success";
			return "primary";
		},
		btnAssignHandleClick() {
			this.$store.commit("moduleActivity/SET_ASSIGNED_ACTIVITIES", this.selected);
			this.customFunction();
		},
		cancel() {
			this.activePromptDelete = false;
			this.activityName = "";
			this.selectedActivity = {};
		},
	},
};
</script>

<style lang="scss" scoped>
#data-list-list-view {
	.vs-con-table {
		@media (max-width: 689px) {
			.vs-table--search {
				margin-left: 0;
				max-width: unset;
				width: 100%;

				.vs-table--search-input {
					width: 100%;
				}
			}
		}

		@media (max-width: 461px) {
			.items-per-page-handler {
				display: none;
			}
		}

		@media (max-width: 341px) {
			.data-list-btn-container {
				width: 100%;

				.dd-actions,
				.btn-add-new {
					width: 100%;
					margin-right: 0 !important;
				}
			}
		}

		.vs-table--header {
			display: flex;
			flex-wrap: wrap;
			margin-left: 1.5rem;
			margin-right: 1.5rem;

			> span {
				display: flex;
				flex-grow: 1;
			}

			.vs-table--search {
				padding-top: 0;

				.vs-table--search-input {
					padding: 0.9rem 2.5rem;
					font-size: 1rem;

					& + i {
						left: 1rem;
					}

					&:focus + i {
						left: 1rem;
					}
				}
			}
		}

		.vs-table {
			padding: 0 1rem;

			td {
				font-style: normal;
				font-weight: 300;
				font-size: 12px;
				line-height: 15px;
				color: #666666;
			}
		}

		.vs-table--thead {
			th {
				padding-top: 0;
				padding-bottom: 0;
			}

			th.td-check {
				padding: 0 15px !important;
			}

			tr {
				background: none;
				box-shadow: none;
			}
		}

		.vs-table--pagination {
			justify-content: center;
		}
	}
}

.g-table--title,
.g-table--description {
	text-align: center;
}
</style>
